/**
 * Formata data/hora no mesmo padrão do chat (MessageItem): pt-BR, fuso America/Araguaina (Araguaína).
 * A API retorna datetimes no fuso Araguaína (UTC-03:00) como "YYYY-MM-DD HH:mm:ss".
 * Para não reinterpretar como UTC no JS, strings nesse formato são apenas reordenadas
 * para DD/MM/YYYY HH:mm:ss (sem vírgula), igual ao parseDisplayDate do MessageItem.
 *
 * @param {string|Date|null|undefined} value - valor vindo da API ou Date
 * @returns {string} "DD/MM/YYYY HH:mm:ss" ou "—" se inválido
 */
export function formatDateTimePtBR(value) {
  if (value == null || value === "") return "—";

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed === "0000-00-00 00:00:00") return "—";
    const mysqlRegex = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?(Z?)$/;
    if (mysqlRegex.test(trimmed)) {
      const normalized = trimmed.replace("T", " ").split(".")[0];
      const [datePart, timePart] = normalized.split(" ");
      if (datePart && timePart) {
        const [year, month, day] = datePart.split("-");
        return `${day}/${month}/${year} ${timePart}`;
      }
    }
  }

  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("pt-BR");
}
